<template>
  <div class="home">
    <div class="hero-container">
      <div class="image-content">
        <v-img height="500" aspect-ratio="1" cover :src="heroImage">
          <div class="hero-content-container">
            <h2 class="headline-image-message pt-15">
              <v-sheet style="color: #2c3e50">
                Changing children's lives for the better
              </v-sheet>
            </h2>
            <!--            <h3 class="subheadline-image-message py-1">
              we help vulnerable young people between 6 and 18 turn the curve on
              their futures by providing the care, education, and therapeutic
              support they need.
            </h3>-->
          </div>
        </v-img>
      </div>
    </div>
    <div class="we-are-container">
      <v-container class="mt-10">
        <v-row>
          <v-col cols="12" md="6">
            <div class="logo-header-container">
              <v-img
                :src="logo"
                max-width="80"
                max-height="80"
                class="logo-img"
              ></v-img>
              <h1 class="we-are-text header-text header-text-xlg text-left">
                We are
                <span style="color: #4599e2; text-decoration: underline"
                  >Blue Skies Care</span
                >
              </h1>
            </div>
            <div class="text-justify">
              <p class="pb-5">
                At Blue Skies Care, we take the time to carefully understand the
                individual needs of every young person in our care. This ensures
                that our core philosophy;
                <strong
                  >providing the highest standard of care in a safe, nurturing
                  and supportive environment,</strong
                >
                enables each young person to reach their full potential, achieve
                their aspirations and prepare them for the next stages of life.
                We offer care, education, and therapeutic support to young
                people from diverse backgrounds who have encountered a range of
                adverse childhood experiences.
              </p>
              <p class="pb-5">
                At the heart of our home is a core belief that every child
                deserves to be safe, seen and celebrated. They deserve to find
                their passions, have their creativity nurtured and thrive in an
                environment that promotes emotional intelligence and
                individuality.
              </p>
              <p class="pb-5">
                With a Trauma informed approach to care and an understanding
                that all children are different and require tailored care, the
                primary aim at Blue Skies Care is to create safe, predictable
                and healing spaces in Residential Children’s homes for Learning
                Disabled children. We use PACE principles ensuring that our
                adults are; Playful, Accepting, Curious and Empathetic.
              </p>
              <p class="pb-5">
                We honour neurodivergent identities and provide sensory-safe
                environments. Routines are predictable, adults feel safe,
                relationships are nurtured and communications styles are
                understood and reciprocated. We respect the rights of children
                and encourage them to take part in their care. Our homes will
                ensure that children’s voices are not only heard but shape
                decision making.
              </p>
            </div>
            <div class="text-left pt-5">
              <!-- <v-btn elevation="2" color="#1C4096" rounded variant="outlined">
                Read more ></v-btn
              > -->
            </div>
          </v-col>
          <v-col cols="12" offset-lg="1" md="5">
            <v-sheet
              class="align-obj-center"
              rounded="xl"
              elevation="15"
              max-width="600"
            >
              <v-img rounded="xl" cover height="300" :src="friendsImg"></v-img>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="strip-container">
      <v-container>
        <v-row>
          <v-col class="header-text header-text-md" cols="12">
            7 in 10 young people in the UK have faced adverse childhood
            experiences by the age of 8. It’s why what we do is so important.
          </v-col>
        </v-row>
        <!-- <v-row class="header-text header-text-md">
          <v-col cols="4">
            <span class="header-text-xlg">1</span>
            <br />
            Care Home
          </v-col>

          <v-col cols="4">
            <span class="header-text-xlg">5 +</span>
            <br />
            Supported Staffs
          </v-col>

          <v-col cols="4">
            <span class="header-text-xlg">10 +</span>
            <br />
            Years of Experiences
          </v-col>
        </v-row> -->
      </v-container>
    </div>
    <div class="related-services">
      <v-container>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-sheet
              class="align-obj-center"
              rounded="xl"
              elevation="15"
              max-width="600"
            >
              <v-img
                rounded="xl"
                cover
                height="300"
                :src="friendSunsetImg"
              ></v-img> </v-sheet
          ></v-col>
          <v-col cols="12" offset-lg="1" md="6" class="text-lg-left">
            <!-- <h1 class="header-text header-text-lg">Therapeutic approach</h1> -->

            <p class="pb-5">
              We understand that for many care-experienced children, living in
              survival mode has been their normal, but with the right balance of
              nurturing and positive experiences, rewiring the brain into safety
              is achievable. This will enable us to help to shape the futures of
              these children, ensuring they thrive, not just survive.
            </p>
            <p class="pb-5">
              We understand and appreciate how tough a job this can be for care
              staff and acknowledge the love, joy and commitment they bring to
              children in care. They are provided with in-depth trauma informed
              care training, receive reflective supervisions, are encouraged to
              develop professionally and we provide fair rotas that prioritise
              wellbeing.
            </p>
            <p class="pb-5">
              Leadership involves being present, understanding emotions, and
              integrating these qualities into daily activities – not just a
              policy. Our success is supported by a dedicated team of staff who
              are highly skilled, experienced, advanced in training and
              ultimately staff that truly want to work and care for young
              people. Most importantly we put our young people at the heart of
              everything we do, with the dedicated support of our talented
              teams, partnerships, and community relationships.
            </p>
            <br />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="location-container mt-5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h1 class="header-text header-text-lg text-center text-lg-left">
              Our Homes
            </h1>
          </v-col>
        </v-row>
        <v-row justify="left">
          <v-col cols="12" md="5" class="text-lg-left">
            <div class="hera-house-container">
              <h2 class="mt-5" style="font-weight: bold">Hera House</h2>
              <p class="text-caption pb-5" style="color: grey">
                Derbyshire/Leicestershire/Staffordshire
              </p>

              <p class="pb-5">
                The name is taken from the powerful queen of the Olympian gods.
                We chose this name as Hera was known to embody regal presence,
                maintained a fierce loyalty to family and was worshipped as a
                protector of women and family life. When naming a home, bringing
                in those values that the home should embody feels as though we
                are honouring the space and setting the intentions for the
                service. The homes ethos is reflected in this name as
                aesthetically pleasing, placing value on family relationships
                and nurturing influence within the home are our foundations. The
                home is strategically placed between 3 counties and can thus
                provide support to either or all the counties.
              </p>
            </div>
          </v-col>

          <v-col cols="12" md="5" class="text-lg-left">
            <div class="hera-house-container">
              <h2 class="mt-5" style="font-weight: bold">Artio House</h2>
              <p class="text-caption pb-5" style="color: grey">
                Greater Manchester
              </p>

              <p class="pb-5">
                The name Artio was taken from the Celtic bear goddess. She was
                often associated with nature, abundance, and transformation.
                She's honoured by many as a powerful archetype of strength, wild
                wisdom, and emotional resilience and she's seen as a guardian
                and a spiritual guide for grounding and healing. Artio house
                aims to offer transformative care based on emotional literacy,
                regulation and resilience providing staff and children an
                abundance of resources and opportunities to grow, develop and
                transform. The home falls under Greater Manchester, North of
                Manchester and stone throw from Lancashire, thus can assist the
                North West.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="coming-soon-section">
      <v-container>
        <v-row class="my-15">
          <v-col class="my-15" cols="12" lg="6" style="margin: 0 auto">
            <v-card class="pa-5" flat style="border: 1px solid lightgrey">
              <v-card-title
                class="header-text header-text-lg client-quote"
                style="color: #1c4096"
                >Coming Soon!</v-card-title
              >
              <div class="header-text-md">
                Our website is currently under development and will be launching
                soon. <br />
                In the meantime, feel free to contact us by
                <a href="mailto:hr@blueskiescaregroup.co.uk">clicking here</a>
                or call us on <a href="tel:07557127790">07557127790</a>
                for any inquiries. Thank you for your patience and support!
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue, toNative } from "vue-facing-decorator";
import heroImg from "@/assets/hero-banner.jpg";
import kidPlayingBallImg from "@/assets/kid-playing-ball.jpg";
import dadWithGirl from "@/assets/dad-with-girl.jpg";
import friendSunsetImg from "@/assets/sunset-friends.jpg";
import groupImg from "@/assets/yankrukov-8612990.jpg";
import locationMap from "@/assets/location-map.jpg";
import friendsImg from "@/assets/friends.jpg";
import logo from "@/assets/logo.png";
@Component({})
class HomeComponent extends Vue {
  heroImage = heroImg;
  kidPlayingBallImg = kidPlayingBallImg;
  dadWithDaughter = dadWithGirl;
  teamGroupImage = groupImg;
  locationMap = locationMap;
  logo = logo;
  friendsImg = friendsImg;
  friendSunsetImg = friendSunsetImg;
}
export default toNative(HomeComponent);
</script>
<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
.header-text {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 700;
}

.header-text-sm {
  font-size: 1rem;
}

.header-text-md {
  font-size: 1.5rem;
}

.header-text-lg {
  font-size: 3.2rem;
}

.header-text-xlg {
  font-size: 4rem;
}

.image-content {
  .headline-image-message {
    font-family: "Bebas Neue", sans-serif;
    font-weight: 700;
    font-size: 3rem;
    width: 900px;
  }

  .subheadline-image-message {
    background-color: $dark-accent;
    opacity: 0.8;
    font-family: "Bebas Neue", sans-serif;
    color: $light-shade;
    font-size: 2rem;
  }

  @media only screen and (max-width: $medium) {
    .headline-image-message {
      font-size: 2rem;
      width: 100%;
      //color: $dark-blue;
    }

    .subheadline-image-message {
      font-size: 1.5rem;
    }
  }
}

.strip-container {
  background-color: $primary-blue;
  color: $light-shade;
  width: 100%;
  margin: 100px 0;
  padding: 50px 0;
}

.logo-header-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-img {
  flex-shrink: 0;
}

@media only screen and (max-width: $large) {
  .we-are-text {
    font-size: 2.7rem;
  }
}

@media only screen and (max-width: $medium) {
  .align-obj-center {
    margin: 0 auto;
  }

  .client-quote {
    font-size: 2.5rem;
  }
}
</style>
